<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>
                <div class=" row p-list-representation-data w-100">
                    <contentList
                        :halls="halls"
                        @modalShowEntryPay="modalShowEntryPay"
                        @searchData="searchData"
                        @selectedCity="selectedCity"
                        @selectedProvince="selectedProvince"
                        :city-selected     = "citySelected"
                        :province-selected = "provinceSelected"
                        :citys="citys"
                        :province-items="provinceItems"
                    />
                </div>
              </div>
          </div>

          <modalTransactionRecord
          :active.sync="showModalTransactionRecord"
          @submitModalDataTransaction="submitModalDataTransaction"
          :click-btn-transaction-value="clickBtnTransactionValue"
          :loading-transaction-form="loadingTransactionForm"
          />
      </Loader>
  </div>
</template>

<script>
import appHeader from '../components/includes/AppHeader'
import contentList from '../components/listSalons/contentList'
import modalTransactionRecord from '../components/listSalonsOwner/modalTransactionRecord'

export default {
  name: 'listSalonsOwner',
  components: {
    appHeader,
    contentList,
    modalTransactionRecord
  },
  data () {
    return {
      loading: true,
      halls: [],
      clickBtnTransactionValue: {},
      showModalTransactionRecord: false,
      loadingTransactionForm: false,
      citys: [],
      provinceItems: [],
      citySelected: {
        id: -1,
        name: 'انتخاب کنید'
      },
      provinceSelected: {
        id: -1,
        name: 'انتخاب کنید'
      },
      updateCitySelected: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      const payload = {
        params:
          {
            include_club: 1
          }
      }
      const that = this
      this.getHalls(payload,
        function (err) {
          console.log(err)
        },
        function (res) {
          if (res.is_successful) {
            that.halls = res.data
          }
        })

      this.getProvinceAndCity()
    })
  },
  methods: {
    modalShowEntryPay (data) {
      this.clickBtnTransactionValue = data
      this.showModalTransactionRecord = true
    },
    submitModalDataTransaction (data) {
      this.loadingTransactionForm = true
      data.club_id = this.clickBtnTransactionValue.club_id

      this.$store
        .dispatch('paySalonOwner/updatePaySalon', {
          data: {
            ...data
          }
        })
        .then((res) => {
          this.loadingTransactionForm = false

          if (res.is_successful) {
            this.showModalTransactionRecord = false
          } else {
            this.$message.error(res.message)
          }
        })
    },
    searchData (data) {
      this.loading = true
      const payload = {
        params:
          {
            include_club: 1,
            name: data.name,
            mobile: data.mobile,
            full_name: data.title
          }
      }
      const that = this
      this.getHalls(payload,
        function (err) {
          console.log(err)
        },
        function (res) {
          if (res.is_successful) {
            that.halls = res.data
          }
        })
    },
    getHalls (payload, err, success) {
      this.$store
        .dispatch('hall/getHalls', payload)
        .then(res => {
          success(res)
        })
        .catch(error => {
          err(error)
        })
        .then(() => {
          this.loading = false
        })
    },
    getProvinceAndCity () {
      this.$store
        .dispatch('hall/getProvinceAndCity', {
        })
        .then((res) => {
          this.getDefaultProvinceAndCity(res)
        })
    },
    getDefaultProvinceAndCity (dataProvinceAndCity) {
      let getProvince = []
      let getCity = []
      const cityIdDefault = this.city_id
      const provinceIdDefault = this.province_id

      dataProvinceAndCity.data.map((t) => {
        getProvince = [...getProvince, t]

        if (provinceIdDefault === t.id) {
          this.provinceSelected = t
        }

        t.city.map((contentCity) => {
          if (cityIdDefault === contentCity.id) {
            this.citySelected = contentCity
          }
          getCity = [...getCity, contentCity]
        })
      })

      this.citys = getCity
      this.provinceItems = getProvince
      this.checkEmptyCity = 'firstCheckSelectedCity'
    },
    selectedCity (data) {
      if (data.id !== -1) {
        this.citySelected = data
        this.city_id = data.id
      }
    },
    selectedProvince (data) {
      if (this.checkEmptyCity !== 'firstCheckSelectedCity') {
        this.citySelected = { name: 'انتخاب کنید', id: -1 }
      }

      if (data.id !== -1) {
        this.provinceSelected = data
        this.province_id = data.id
        this.updateCitySelected++
        this.citys = data.city
        this.checkEmptyCity = 'eventUpdate'
      }
    }
  }
}
</script>
